import {createAsyncThunk} from '@reduxjs/toolkit';
import {AxiosInstance, AxiosResponse} from 'axios';
//enum
import {ACTION_TYPE} from '../actions-types';
//types
import {
	IOrganizationTicketsListResponse,
	IOrganizationTicketsListRequest,
	IOrganizationTicketsTiers,
	IOrganizationTicketsStatistics,
	IRequestWithPagination,
	IOrganizationTablesAndTicketsAvailableResponse,
	IOrganizationTableTicketsResponse,
} from '../../utils/types';
//services
import {OrganizationTableAndTicketsService} from '@/utils/services';
//helpers
import {getErrorResponse} from '@/utils/helpers';

export const getTicketsList = createAsyncThunk(
	ACTION_TYPE.TABLES_AND_TICKETS_TICKETS_LIST,
	async (
		{reqBody, apiInstance}: {reqBody: IOrganizationTicketsListRequest; apiInstance: AxiosInstance},
		{rejectWithValue}
	) => {
		try {
			const tablesAndTicketsResponse: AxiosResponse<IOrganizationTicketsListResponse> =
				await OrganizationTableAndTicketsService.getTicketsList(reqBody, apiInstance);

			return tablesAndTicketsResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const getTicketsTiers = createAsyncThunk(
	ACTION_TYPE.TABLES_AND_TICKETS_TICKETS_TIERS,
	async ({reqBody, apiInstance}: {reqBody: number; apiInstance: AxiosInstance}, {rejectWithValue}) => {
		try {
			const tablesAndTicketsResponse: AxiosResponse<IOrganizationTicketsTiers[]> =
				await OrganizationTableAndTicketsService.getTicketsTiers(reqBody, apiInstance);

			return tablesAndTicketsResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const getTicketsStatistics = createAsyncThunk(
	ACTION_TYPE.TABLES_AND_TICKETS_STATISTICS,
	async (reqBody: number, {rejectWithValue}) => {
		try {
			const tablesAndTicketsResponse: AxiosResponse<IOrganizationTicketsStatistics> =
				await OrganizationTableAndTicketsService.getTicketsStatistics(reqBody);

			return tablesAndTicketsResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const getTableAndTicketsAvailable = createAsyncThunk(
	ACTION_TYPE.TABLES_AND_TICKETS_AVAILABLE,
	async (reqBody: IRequestWithPagination, {rejectWithValue}) => {
		try {
			const tablesAndTicketsResponse: AxiosResponse<IOrganizationTablesAndTicketsAvailableResponse> =
				await OrganizationTableAndTicketsService.getTableAndTicketsAvailable(reqBody);

			return tablesAndTicketsResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const getTableTickets = createAsyncThunk(
	ACTION_TYPE.TABLES_AND_TICKETS_TICKETS,
	async ({reqBody, apiInstance}: {reqBody: number; apiInstance: AxiosInstance}, {rejectWithValue}) => {
		try {
			const tablesAndTicketsResponse: AxiosResponse<IOrganizationTableTicketsResponse> =
				await OrganizationTableAndTicketsService.getTableTickets(reqBody, apiInstance);

			return tablesAndTicketsResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const updateTicketStatus = createAsyncThunk(
	ACTION_TYPE.TABLES_AND_TICKETS_UPDATE_TICKET_STATUS,
	async (
		reqBody: {
			tableId: number;
			isPaid: boolean;
		},
		{rejectWithValue}
	) => {
		try {
			const tablesAndTicketsResponse: AxiosResponse<IOrganizationTableTicketsResponse> =
				await OrganizationTableAndTicketsService.updateTicketStatus(reqBody);

			return tablesAndTicketsResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);


export const getPrivateTicketsTiers = createAsyncThunk(
	ACTION_TYPE.TABLES_AND_TICKETS_TICKETS_TIERS_PRIVATE,
	async ({eventId, token, apiInstance}: {eventId: number; token: string; apiInstance: AxiosInstance}, {rejectWithValue}) => {
		try {
			const tablesAndTicketsResponse: AxiosResponse<IOrganizationTicketsTiers[]> =
				await OrganizationTableAndTicketsService.getTicketsTiersByPrivateLink(eventId, token, apiInstance);

			return tablesAndTicketsResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);
